module.exports = __webpack_public_path__ + "img/food-sensitivity-journal_B09MYVVRF2.a1496c58.jpg";